import { defineComponent, ref, computed, openBlock, createElementBlock, createElementVNode, createVNode, unref, withCtx, createTextVNode, createBlock, normalizeClass, Fragment, renderList, createCommentVNode, toDisplayString } from "vue";
import { CdrAccordion, CdrList, CdrTable, CdrLink, CdrAccordionGroup } from "@rei/cedar";
const _hoisted_1 = {
  class: "kids-size-guide-modal"
};
const _hoisted_2 = {
  class: "kids-size-guide-modal__accordion-content",
  "data-ui": "kids-size-guide-accordion-content"
};
const _hoisted_3 = {
  class: "kids-size-guide-modal__header-row"
};
const _hoisted_4 = {
  class: "kids-size-guide-modal__cell-content"
};
const _hoisted_5 = {
  class: "kids-size-guide-modal__size"
};
const _hoisted_6 = {
  key: 0,
  class: "pdp-sr-only"
};
const _hoisted_7 = {
  class: "pdp-sr-only"
};
const _hoisted_8 = {
  class: "kids-size-guide-modal__cell-content"
};
const _hoisted_9 = {
  "aria-hidden": "true"
};
const _hoisted_10 = {
  class: "pdp-sr-only"
};
const _hoisted_11 = {
  key: 0,
  class: "kids-size-guide-modal__current-size-badge",
  "aria-hidden": "true"
};
const _hoisted_12 = {
  class: "kids-size-guide-modal__general-guidance"
};
const _hoisted_13 = {
  class: "kids-size-guide-modal__accordion-content"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "KidsSizeFinderModal",
  props: {
    size: {
      default: ""
    },
    kidsBikeSizeGuide: {
      default: () => [{
        size: "",
        inseam: "",
        height: "",
        age: "",
        url: "",
        linkName: "",
        ageSrOnly: "",
        urlSrOnly: ""
      }]
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const isKidsSizeAccordionOpen = ref(false);
    const kidsTipsAccordions = ref([{
      id: "kids-size-guide-modal__tips-accordion0",
      label: "Buy a bike that fits today",
      content: "If you’re buying a bike for a young rider, it’s easy to want one they’ll grow into. But it’s important to get one that fits now, especially for beginning riders. A properly sized bike will be easier to handle, safer and more fun to ride.",
      opened: false
    }, {
      id: "kids-size-guide-modal__tips-accordion1",
      label: "Planning for growth",
      content: "If your child is in between sizes and has been riding for a while, it’s okay to size up so they don’t outgrow their new bike too quickly.",
      opened: false
    }, {
      id: "kids-size-guide-modal__tips-accordion2",
      label: "How kids’ bikes are sized",
      content: "Kids’ bikes are typically sized based on wheel size, but exact frame dimensions can vary from bike to bike.",
      opened: false
    }]);
    const sizeIndex = computed(() => props.kidsBikeSizeGuide.findIndex((kidsBikeSize) => kidsBikeSize.size === props.size));
    const removeHeaderBottomBorderClass = computed(() => sizeIndex.value === 0 ? "kids-size-guide-modal__header--no-bottom-border" : "");
    function rowCurBikeSizeClass(tableRowIndex) {
      return props.size === props.kidsBikeSizeGuide[tableRowIndex].size ? "kids-size-guide-modal__table-row--current-size" : "";
    }
    function removeCellBottomBorderClass(tableRowIndex) {
      const nextRowIndex = tableRowIndex + 1;
      return nextRowIndex === sizeIndex.value ? "kids-size-guide-modal__cell--no-bottom-border" : "";
    }
    function handleShopAllLink(event, link, linkName) {
      emits("metricsClick", {
        linkName,
        event
        // omit link to open new tab
      });
    }
    function handleFindStore(event) {
      emits("metricsClick", {
        linkName: "bike-size_shop in store",
        event
        // omit link to open new tab
      });
    }
    function toggleAccordion(index) {
      kidsTipsAccordions.value.forEach((accordion, accIndex) => {
        if (accIndex !== index) {
          kidsTipsAccordions.value[accIndex].opened = false;
        }
      });
      kidsTipsAccordions.value[index].opened = !kidsTipsAccordions.value[index].opened;
    }
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", _hoisted_1, [_cache[11] || (_cache[11] = createElementVNode("p", {
        class: "kids-size-guide-modal__intro-text"
      }, " We recommend using your child’s inseam (inside leg length) for the most accurate sizing. Height also works for most kids. ", -1)), createVNode(unref(CdrAccordion), {
        id: "kids-size-guide-modal__accordion",
        class: "kids-size-guide-modal__accordion",
        level: "2",
        compact: true,
        opened: isKidsSizeAccordionOpen.value,
        onAccordionToggle: _cache[0] || (_cache[0] = ($event) => isKidsSizeAccordionOpen.value = !isKidsSizeAccordionOpen.value)
      }, {
        label: withCtx(() => _cache[2] || (_cache[2] = [createElementVNode("div", {
          "data-ui": "kids-size-guide-accordion-label"
        }, [createTextVNode(" How to measure your child’s inseam "), createElementVNode("span", {
          style: {
            "display": "inline-block"
          }
        }, "(inside leg length)")], -1)])),
        default: withCtx(() => [createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = createElementVNode("p", {
          class: "kids-size-guide-modal__list-instructions"
        }, " Grab a large hardcover book or notebook, a tape measure and a pencil. ", -1)), createVNode(unref(CdrList), {
          tag: "ol",
          modifier: "ordered"
        }, {
          default: withCtx(() => _cache[3] || (_cache[3] = [createElementVNode("li", {
            class: "kids-size-guide-modal__list-item"
          }, " Have your child stand against a wall with their shoes on. ", -1), createElementVNode("li", {
            class: "kids-size-guide-modal__list-item"
          }, " Put the book (spine up) between the child’s legs, as high as it will go. ", -1), createElementVNode("li", {
            class: "kids-size-guide-modal__list-item"
          }, " Use the pencil to mark where the spine of the book meets the wall. Measure from that mark to the floor. This is their inseam. ", -1)])),
          _: 1,
          __: [3]
        })])]),
        _: 1
      }, 8, ["opened"]), _ctx.kidsBikeSizeGuide.length ? (openBlock(), createBlock(unref(CdrTable), {
        key: 0,
        class: "kids-size-guide-modal__table",
        "aria-label": "size chart",
        "full-width": "",
        border: false
      }, {
        default: withCtx(() => [createElementVNode("thead", null, [createElementVNode("tr", _hoisted_3, [createElementVNode("th", {
          scope: "col",
          class: normalizeClass(`kids-size-guide-modal__header
              kids-size-guide-modal__first-col
              ${removeHeaderBottomBorderClass.value}`)
        }, " Kids' bike size ", 2), createElementVNode("th", {
          scope: "col",
          class: normalizeClass(`kids-size-guide-modal__header
              ${removeHeaderBottomBorderClass.value}`)
        }, _cache[5] || (_cache[5] = [createElementVNode("div", {
          class: "kids-size-guide-modal__header-rating"
        }, " Best ", -1), createTextVNode(" Inseam "), createElementVNode("br", null, null, -1), createTextVNode("(inside leg length) ")]), 2), createElementVNode("th", {
          scope: "col",
          class: normalizeClass(`kids-size-guide-modal__header
              ${removeHeaderBottomBorderClass.value}`)
        }, " Height of child ", 2), createElementVNode("th", {
          scope: "col",
          class: normalizeClass(`kids-size-guide-modal__header kids-size-guide-modal__last-col
              ${removeHeaderBottomBorderClass.value}`)
        }, " Approx. age ", 2)])]), createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.kidsBikeSizeGuide, (kidsSize, tableRowIndex) => {
          return openBlock(), createElementBlock("tr", {
            key: kidsSize.size,
            class: normalizeClass(`kids-size-guide-modal__table-row ${rowCurBikeSizeClass(tableRowIndex)}`),
            "data-ui": "kids-size-guide-table-row"
          }, [createElementVNode("td", {
            class: normalizeClass(`kids-size-guide-modal__cell  kids-size-guide-modal__first-col
            ${removeCellBottomBorderClass(tableRowIndex)}`)
          }, [createElementVNode("div", _hoisted_4, [createElementVNode("div", _hoisted_5, [tableRowIndex === sizeIndex.value ? (openBlock(), createElementBlock("span", _hoisted_6, " This bike ")) : createCommentVNode("", true), createTextVNode(" " + toDisplayString(kidsSize.size), 1)]), createVNode(unref(CdrLink), {
            href: `/c/kids-bikes${kidsSize.url}`,
            target: "_blank",
            onClick: ($event) => handleShopAllLink($event, `/c/kids-bikes${kidsSize.url}`, kidsSize.linkName)
          }, {
            default: withCtx(() => [_cache[6] || (_cache[6] = createTextVNode(" Shop all ")), createElementVNode("span", _hoisted_7, toDisplayString(kidsSize.urlSrOnly) + " bikes", 1)]),
            _: 2,
            __: [6]
          }, 1032, ["href", "onClick"])])], 2), createElementVNode("td", {
            class: normalizeClass(`kids-size-guide-modal__cell ${removeCellBottomBorderClass(tableRowIndex)}`)
          }, toDisplayString(kidsSize.inseam), 3), createElementVNode("td", {
            class: normalizeClass(`kids-size-guide-modal__cell ${removeCellBottomBorderClass(tableRowIndex)}`)
          }, toDisplayString(kidsSize.height), 3), createElementVNode("td", {
            class: normalizeClass(`kids-size-guide-modal__cell kids-size-guide-modal__last-col
            ${removeCellBottomBorderClass(tableRowIndex)}`)
          }, [createElementVNode("div", _hoisted_8, [createElementVNode("span", _hoisted_9, toDisplayString(kidsSize.age), 1), createElementVNode("span", _hoisted_10, toDisplayString(kidsSize.ageSrOnly), 1)]), tableRowIndex === sizeIndex.value ? (openBlock(), createElementBlock("div", _hoisted_11, " This bike ")) : createCommentVNode("", true)], 2)], 2);
        }), 128))])]),
        _: 1
      })) : createCommentVNode("", true), createElementVNode("h2", _hoisted_12, [_cache[8] || (_cache[8] = createElementVNode("span", null, "Note:", -1)), _cache[9] || (_cache[9] = createTextVNode(" The above chart is a rough guide to help find the right size for your child. For a more personalized fit, see a bike expert at ")), createVNode(unref(CdrLink), {
        href: "/stores/map",
        target: "_blank",
        onClick: _cache[1] || (_cache[1] = ($event) => handleFindStore($event))
      }, {
        default: withCtx(() => _cache[7] || (_cache[7] = [createTextVNode(" your local REI Co-op ")])),
        _: 1,
        __: [7]
      }), _cache[10] || (_cache[10] = createTextVNode(". "))]), _cache[12] || (_cache[12] = createElementVNode("h2", {
        class: "kids-size-guide-modal__tips-header"
      }, " Tips for kids’ bike sizing ", -1)), ((_a = kidsTipsAccordions.value) == null ? void 0 : _a.length) ? (openBlock(), createBlock(unref(CdrAccordionGroup), {
        key: 1,
        class: "kids-size-guide-modal__tips-accordion-wrapper"
      }, {
        default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(kidsTipsAccordions.value, (accordion, index) => {
          return openBlock(), createBlock(unref(CdrAccordion), {
            id: accordion.id,
            key: accordion.id,
            ref_for: true,
            ref: accordion.id,
            class: "kids-size-guide-modal__tips-accordion",
            level: "3",
            compact: true,
            opened: accordion.opened,
            onAccordionToggle: ($event) => toggleAccordion(index)
          }, {
            label: withCtx(() => [createTextVNode(toDisplayString(accordion.label), 1)]),
            default: withCtx(() => [createElementVNode("div", _hoisted_13, toDisplayString(accordion.content), 1)]),
            _: 2
          }, 1032, ["id", "opened", "onAccordionToggle"]);
        }), 128))]),
        _: 1
      })) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=KidsSizeFinderModal2.mjs.map
